import { makeStyles } from "tss-react/mui"
import { Box, Checkbox, MenuItem, Typography } from "@mui/material"
import { ResourceFilterElementValue } from "../../../createOrderTypes"
import { LocalizedEnum } from "../../../../../../modules/localization/components/AppLocalized"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faCheck } from "@fortawesome/pro-solid-svg-icons"

const useStyles = makeStyles()((theme) => ({
    container: {
        padding: ".5rem 0",
        maxWidth: "20rem",
        minWidth: "14.5rem",
    },
    checkbox: {
        padding: "0",
    },
    menuItemWrap: {
        display: "grid",
        gridTemplateColumns: "1rem 1fr 3rem",
        width: "100%",
        gap: "1rem",
        alignItems: "center",
        color: theme.palette.tailwind.slate[950],
    },
    menuItemCheckWrap: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
    },
    image: {
        width: "2rem",
        height: "2rem",
        objectFit: "cover",
    },
    selectedIcon: {
        color: theme.palette.tailwind.slate[900],
    },
}))

type MultiSelectFilterProps = {
    identifier: string
    values: ResourceFilterElementValue[]
    localValues: ResourceFilterElementValue[]
    onToggle: (value: ResourceFilterElementValue) => void
}

export function MultiSelectFilter({ values, localValues, onToggle, identifier }: MultiSelectFilterProps) {
    const { classes } = useStyles()

    return (
        <Box className={classes.container}>
            <LocalizedEnum base="resource-booking-chip-filter-select-title" enumValue={identifier}>
                <Typography fontWeight={600} paddingLeft="1rem" marginBottom="1rem">
                    Select
                </Typography>
            </LocalizedEnum>
            {values.map((value) => {
                const isSelected = localValues.some((v) => v.key === value.key)

                return value.imageUrl ? (
                    <MenuItem
                        key={`${value.value}_${value.key}`}
                        onClick={() => onToggle(value)}
                        className={classes.menuItemWrap}
                    >
                        <Checkbox checked={isSelected} className={classes.checkbox} />
                        <Typography variant="body1">{value.key}</Typography>
                        {value.imageUrl && (
                            <img src={value.imageUrl} alt={value.key.toString()} className={classes.image} />
                        )}
                    </MenuItem>
                ) : (
                    <MenuItem
                        key={`${value.value}_${value.key}`}
                        onClick={() => onToggle(value)}
                        className={classes.menuItemCheckWrap}
                    >
                        <Typography variant="body1">{value.key}</Typography>
                        {isSelected && <FontAwesomeIcon className={classes.selectedIcon} icon={faCheck} size="sm" />}
                    </MenuItem>
                )
            })}
        </Box>
    )
}
